import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GestionesocietaComponent } from './pages/company-management/gestionesocieta.component';
import { DetailCompanyComponent } from './pages/detail-company/detail-company.component';
import { authGuardLEMFn } from 'src/app/guards/auth.guard-lem';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';

const routes: Routes = [
  {
    path: '',
    data: { descrittore: NomiDescrittoriSezione.DESCRITTORE_GESTIONE_SOCIETA },
    canActivate: [authGuardLEMFn],
    canActivateChild: [authGuardLEMFn],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: GestionesocietaComponent,
      },
      {
        path: 'dettaglio/:id',
        data: {title: "Gestione società - dettaglio"},
        component: DetailCompanyComponent
      }
    ]
  }
]

@NgModule({
  declarations: [

  ],
  imports: [
    RouterModule.forChild(routes),

  ],
  exports: [RouterModule]
})
export class GestionesocietaLemRoutingModule { }
